import React, {Component} from 'react'

const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <img {...props} src="/img/arrow-left-big.svg"/>
)

export default SlickArrowLeft
